import React from 'react';
import { Instagram, Linkedin, Twitter } from 'lucide-react';
import { FOOTER } from '@/constants/testIds';

const LINKS = [
  { id: 'services', label: 'Services' },
  { id: 'work', label: 'Work' },
  { id: 'process', label: 'Process' },
  { id: 'pricing', label: 'Pricing' },
  { id: 'contact', label: 'Contact' },
];

function scrollToId(id) {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: 'smooth' });
}

export default function Footer() {
  return (
    <footer className="relative" data-testid={FOOTER.block} style={{ background: '#0F1A33', color: '#FFFFFF' }}>
      {/* Subtle SVG hex strip at top */}
      <div className="relative h-3 overflow-hidden" aria-hidden>
        <svg className="absolute inset-0 w-full h-full" preserveAspectRatio="none" viewBox="0 0 1200 12">
          <line x1="0" y1="6" x2="1200" y2="6" stroke="rgba(232, 154, 31, 0.5)" strokeWidth="0.5" />
        </svg>
      </div>
      <div className="container-pro px-4 md:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 items-start">
          <div>
            <img src="/logo.png" alt="SiteHive" className="h-10 w-auto rounded-md" style={{ background: '#FFFFFF', padding: '4px 8px' }} />
            <p className="mt-5 font-display text-[1.05rem] text-white/80 max-w-xs italic">
              Websites that build your business.
            </p>
          </div>
          <nav className="flex flex-wrap gap-x-6 gap-y-3 md:justify-center">
            {LINKS.map((l) => (
              <button
                key={l.id}
                onClick={() => scrollToId(l.id)}
                className="text-[13.5px] text-white/65 hover:text-[color:#F5C56D] transition-colors"
              >
                {l.label}
              </button>
            ))}
          </nav>
          <div className="flex md:justify-end gap-3">
            {[
              { Icon: Instagram, href: 'https://instagram.com/sitehive.in', label: 'Instagram' },
              { Icon: Linkedin,  href: 'https://www.linkedin.com/company/sitehive', label: 'LinkedIn' },
              { Icon: Twitter,   href: 'https://twitter.com/sitehive_in', label: 'Twitter' },
            ].map(({ Icon, href, label }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                className="w-9 h-9 inline-flex items-center justify-center rounded-lg border border-white/15 hover:border-[color:#F5C56D] hover:text-[color:#F5C56D] transition-colors"
              >
                <Icon size={16} />
              </a>
            ))}
          </div>
        </div>
        <div className="mt-10 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-[11px] text-white/55 font-accent tracking-[0.22em] uppercase">
            © 2026 SiteHive. All rights reserved. · sitehive.in
          </p>
          <p className="text-[12px] text-white/55">Crafted in Delhi, India.</p>
        </div>
      </div>
    </footer>
  );
}
